var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 24,
    viewBox: "0 0 45 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5857 13.0607C44.1714 12.4749 44.1714 11.5251 43.5857 10.9393L34.0397 1.3934C33.4539 0.807612 32.5042 0.807612 31.9184 1.3934C31.3326 1.97918 31.3326 2.92893 31.9184 3.51472L40.4037 12L31.9184 20.4853C31.3326 21.0711 31.3326 22.0208 31.9184 22.6066C32.5042 23.1924 33.4539 23.1924 34.0397 22.6066L43.5857 13.0607ZM0 13.5H42.525V10.5H0V13.5Z",
    fill: "url(#paint0_linear_574_578)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_574_578",
    x1: 21.2625,
    y1: -8,
    x2: 21.2625,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#F08143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.f187204b7c60606fb945e79ff03d4978.svg";
export { ForwardRef as ReactComponent };